export const ACTION = {
    SAVE_PREFERRED_LANGUAGES: "SAVE_PREFERRED_LANGUAGES",
    FETCH_LANGUAGE_LISTING: "FETCH_LANGUAGE_LISTING",
    OPEN_MOBILEPOPUP: "OPEN_MOBILEPOPUP",
    CLOSE_MOBILEPOPUP: "CLOSE_MOBILEPOPUP",
    FETCH_SELECTED_LANGUAGE: "FETCH_SELECTED_LANGUAGE",
};

export const MAX_LANGUAGE_ERROR_MESSAGE = 'You can select max 5 languages.';
export const MAX_LANGUAGE_ALLOWED = 5;
